import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IAmenities, ITestimonialData } from '../../types/api/homeApi';
import { NoData } from '../common/NoData';
import { useTranslation } from 'react-i18next';
import { ISubAminity, ISubTestimonial } from '../../types/features/multiLanguageSlice';

const Testimonials: React.FC<{ testimonials: Array<ITestimonialData>, amenities: Array<IAmenities> }> = ({ testimonials, amenities }) => {
    const { t } = useTranslation()
    const testimonials_json = t('home.testimonial.testimonials', { returnObjects: true }) as ISubTestimonial[];
    const aminity_json = t('aminity.aminities', { returnObjects: true }) as ISubAminity[];

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        arrows: true,
        dots: true,
        speed: 300,
        margin: '10px',
        centerPadding: '80px',
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [

            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '0px',
                    arrows: true,
                    dots: false,

                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '0px',
                    arrows: true,
                    dots: false,

                }
            },
            {
                breakpoint: 399,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '0px',
                    arrows: false,
                    dots: false,

                }
            }

        ]
    };
    return (
        <>
            <div className='testimonial inner-padding'></div>
            <section className='client-main'>
                <div className='container'>
                    <div className='client-box'>
                        <Row className='reasponsive-align'>
                            <Col lg={6} md={12}>
                                <div className='client-box-info'>
                                    <h3>{t('home.testimonial.title')}</h3>
                                    <Slider {...settings}>
                                        {testimonials && testimonials.length > 0 ?
                                            testimonials.map((testimonial: ITestimonialData, index: number) => (
                                                <div className='client-slider-info' key={'testimonials_' + index}>
                                                    <p className='feedback-text'>{testimonials_json && testimonials_json.length > 0 && testimonials_json[index].feedback}</p>
                                                    <div className='designation'>
                                                        <ul>
                                                            <li>
                                                                <div className='pro-pic'>
                                                                    <img src={testimonial.customer_image} alt='demo' />
                                                                </div>
                                                                <div className='pro-info'>
                                                                    <h5>{testimonials_json && testimonials_json.length > 0 && testimonials_json[index].customer_name}</h5>
                                                                    <p>{testimonials_json && testimonials_json.length > 0 && testimonials_json[index].customer_designation}</p>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            ))
                                            :
                                            <NoData message='Oops!! No Testinmonial Data Found..' />
                                        }
                                    </Slider>
                                </div>
                            </Col>
                            <Col lg={6} md={12}>
                                <div className='test-img-video'>
                                    <img src={require('../../assets/images/hero_backg.jpg')} alt='demo' />
                                    <div className='overlay-3'></div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className='amenities'>
                        <Row>
                            {amenities && amenities.length > 0 ?
                                amenities.map((amenitie: IAmenities, index: number) => (
                                    <Col md={6} sm={6} lg={4} key={'amenities_' + index}>
                                        <div className='amenities-box'>
                                            <img src={`${amenitie.photo}`} alt='demo' />
                                            <h4>{aminity_json && aminity_json.length > 0 && aminity_json[index].title}</h4>
                                            <p>{aminity_json && aminity_json.length > 0 && aminity_json[index].description}</p>
                                        </div>
                                    </Col>
                                ))
                                : <NoData message='Oops, No Aminities Data Found!!' />}
                        </Row>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Testimonials